import { render, staticRenderFns } from "./Upsell.vue?vue&type=template&id=05305b79&scoped=true"
import script from "./Upsell.vue?vue&type=script&lang=js"
export * from "./Upsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05305b79",
  null
  
)

export default component.exports